/**
 * Application entry point
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Start MSW for mocking API in development
async function enableMocking() {
  // Only enable in development mode
  if (import.meta.env.MODE !== "development") {
    return;
  }

  const { worker } = await import("./test/mocks/browser");

  return worker.start({
    onUnhandledRequest: "bypass",
    serviceWorker: {
      url: "/mockServiceWorker.js",
    },
    quiet: false,
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element not found. Make sure there is a div with id="root" in index.html',
  );
}

enableMocking().then(() => {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
